import React from 'react'

import { useSelector, useDispatch } from "react-redux";

export default function Modal() {

    let Component = useSelector(state => state.ModalReducer.Component)

    return (
        <div>
            <div class="modal fade" id="modelId" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            {/* <h5 class="modal-title">Modal title</h5> */}
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {Component}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            {/* <button type="button" class="btn btn-primary">Save</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

